import React, { useState, useContext, createRef, useEffect } from 'react';
import { Header, Checkbox, Card, Container, Segment, Sticky, Grid, Input, GridRow, Divider, GridColumn, ButtonContent } from 'semantic-ui-react';
import { Button, List, Form, Icon, Modal, Label, Progress, Message } from 'semantic-ui-react';
import { Link, useParams } from 'react-router-dom';
import { AppState, StateProvider } from '../../context';
import MedCheckBox from './MedCheckBox.js';
import { dbFamMember, dbTasks, dbSeniors } from '../../firebase';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';


const Senior = ({ user, inst }) => {
  const [currentDate, setNewDate] = useState(null);
  const TestDate = () => {

    const onChange = (e, data) => {
      setNewDate(currentDate => data.value)
      console.log(data.value);
      console.log(currentDate)
      setDate(data.value);
      // console.log(data)
      // console.log()

    };
    return <SemanticDatepicker
      onChange={onChange}
      clearable={true}
      keepOpenOnClear={true}
      locale="en-US"
      value={date}
    />;
  };
  const someContext = useContext(AppState);
  const [date, setDate] = useState(new Date());
  const contextRef = createRef();
  const { userid, bool } = useParams();
  const [seniorfirstName, setSeniorFirstName] = useState("")
  const [seniorlastName, setSeniorLastName] = useState("")
  const [existingSeniors, setExistingSeniors] = useState([])
  const [seniorMedications, setMedications] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [oneMedicine, setMedication] = useState("")
  const [medicineBool, setMedicineBool] = useState(false);



  var temp = []
  function updateMedications() {
    console.log("called function");
    temp = seniorMedications;
    temp.push(oneMedicine)
    setMedications(temp)
    setMedication("");
  }

  function WriteFirebase() {
    console.log("the date is")
    console.log(toString(date))
    const Issues = {
      "Asthma": true,
      "Back Pain": true
    }
    const dataToPush = {
      "firstName": seniorfirstName,
      "lastName": seniorlastName,
      "familyMember": userid,
      "birthdate": 87989979,
      "HealthIssues": Issues
    }
    let k = dbSeniors.push(dataToPush);
    let key = k.key;

    dbFamMember.child(userid).update({ seniors: key })
    dbFamMember.child(userid).update({ seniorBool: true })


    let temp = existingSeniors
    temp.push(key)
    setExistingSeniors(temp)
    dbFamMember.child(userid).update({ seniors: temp })


    dbSeniors.child(key).update({
      ["Medications"]: "true"
    })

    for (let i = 0; i < seniorMedications.length; i++) {
      dbSeniors.child(key).child("Medications").update(
        {
          [seniorMedications[i]]: true
        }
      )
    }
    reboot();
  }
  function reboot() {
    setSeniorFirstName("")
    setSeniorLastName("")
    setMedication("")
    setMedications([])
    setDate(null)
  }
  const PageHeader = () => {
    var header = inst ? inst : "Homecare"
    return (
      <Segment
        basic
        style={{ backgroundColor: "#006990", textAlign: "center", marginBottom: "0px" }}
        fluid="true"
      >
        <Grid columns={2}>
          <Grid.Column width='3' />
          <Grid.Column width='10'>
            <Header
              as={Link}
              to="/"
              inverted
              content={header}
              size="large"
              color="black"
              style={{ cursor: "default" }}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  };
   var redirect= !inst ? `/familymembers/register/famques/${userid}` : `/${inst}/familymembers/register/famques/${userid}`

  return (
    <div ref={contextRef}>
      <PageHeader />
      <Sticky context={contextRef} >
        <Grid textAlign='center' style={{ height: '10vh' }} padded>

          <Modal open={isModalOpen} basic size='small' onClose={() => setIsModalOpen(false)}>
            <Header icon='checkmark' content='Complete!' />
            <Modal.Content>
              <p>
                You are all set up, you will now be redirected to your tasklist
            </p>
            </Modal.Content>
            <Modal.Actions style={{ textAlign: "center" }}>
              <Button color='green' inverted onClick={() => {
                setIsModalOpen(false);
              }}>
                <Icon name='pen square' /> Add Another
      </Button>
              <Button centered color='green' inverted as={Link} to={bool == 0 ? redirect : `/familymembers`} onClick={() => WriteFirebase()} >
                {/* to={`/familymembers/register/recommended/${userid}`}  */}
                <Icon name='checkmark' /> Proceed
      </Button>
            </Modal.Actions>
          </Modal>
          {/* <Form.Group widths='equal' style={{marginTop:"10px"}}>
                <Form.Input
                  required={true}
                  onChange={(e) => { setMedication(e.target.value.toUpperCase()) }}
                  value={oneMedicine}
                  label='Add Medications:'
                  id='medicationsInput'
                  style={{ width: '200px' }}
                />
                {/* <Form.Button icon="list alternate" compact size="small" style={{ marginLeft: "-16px ", marginTop: '30px' }}/> */}
          {/* </Form.Group> */}
          {/* <div alignItems="center">
            <Button content="Add" size='big' onClick={() => updateMedications()} compact style={{}} />
          </div>
          <Grid.Row style={{ marginLeft: "100px", marginRight: "100px", alignItems: "left" }}>
            {seniorMedications.map(function name(params) {
              return (
                <Label size="mini" color='green' horizontal style={{marginBottom:"5px"}}>
                  {seniorMedications.length != 0 ? params : null}
                </Label>
              )
            })} */}
          {/* </Grid.Row> */}
          {/* <Form.Group style={{marginTop:"10px"}}>
            <TestDate />
          </Form.Group> */}

          <Divider hidden />
          <Grid.Row>
            <Grid.Column style={{ marginLeft: "30px", marginRight: "30px", maxWidth: 450 }}>
              <Progress percent={50} indicating />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as="h5">
                Please enter the information of the person being cared for:
              </Header>
              <Form size='large' >
                <Segment stacked>
                  <Form.Input
                    required={true}
                    onChange={(e) => { setSeniorFirstName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='First Name'
                  />
                  <Form.Input
                    required={true}
                    onChange={(e) => { setSeniorLastName(e.target.value) }}
                    id='form-subcomponent-shorthand-input-first-name'
                    placeholder='Last Name'
                  />

                  <Button color='teal' fluid size='large' onClick={() => setIsModalOpen(true)}>
                    Continue
        </Button>
                </Segment>
                {/* {error ? <div style={{ maxWidth: 450 }}>
                  <Message
                    warning
                    floating
                    content="This username already exists! Please choose another"
                    size="tiny"
                  />
                </div> : ""} */}
              </Form>
              <Message>
                Your privacy is important to us<a href='/privacy'> Privacy policy</a>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Sticky>
    </div>
  );
}

export default Senior;